<div class="info-container">

  <div [innerHTML]="'Documents.All.Help.Title' | translate | safe:'html'"
       class="title u-blue">
  </div>
  <hr>
  <app-passport-info></app-passport-info>
  <hr>
  <app-driving-license-info></app-driving-license-info>
  <hr>
  <app-id-info></app-id-info>
</div>
